import React from 'react'
import { AsyncState, async } from 'widgets-for-react'
import { BlocksState } from '../cmsPage/blocks/blocksState'
import { blocksWidget } from '../cmsPage/blocks/blocksWidget'
import { CrisisBannerLayout } from './crisisBannerLayout'
import { crisisbannerStateUpdaters } from './crisisbannerState'

export const crisisBannerWidget = (acceptVideoCookiebarCookie: () => void) => (state: AsyncState<BlocksState>) =>
  async<BlocksState>(state, page =>
    blocksWidget(acceptVideoCookiebarCookie)(page)
      .wrapHTML((element) => <CrisisBannerLayout child={element} />)
      .map(crisisbannerStateUpdaters.blocksStateUpdater)
  )
